<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <!-- Barre de progression -->
    <app-progress-bar
      [currentStep]="currentStep"
      [totalSteps]="totalSteps"
    ></app-progress-bar>

    <!-- Loading state -->
    @if (isLoading) {
      <div class="text-center py-12 mt-4">
        <svg
          class="animate-spin h-10 w-10 text-indigo-600 mx-auto mb-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <p class="text-gray-600 dark:text-gray-400 text-sm">Calcul de votre potentiel...</p>
      </div>
    }

    <!-- Contenu principal -->
    @if (!isLoading) {
      <div class="space-y-4">
        <!-- Titre et intro -->
        <div class="mb-3 mt-3">
          <h1 class="text-xl font-bold text-gray-900 dark:text-white mb-1">
            💰 Votre potentiel économique
          </h1>
          <p class="text-gray-600 dark:text-gray-400 text-xs">
            Estimations basées sur votre profil et nos données
          </p>
        </div>
        <!-- Économies estimées - MIS EN AVANT -->
        <div
          class="bg-gradient-to-br from-green-50 to-emerald-50 p-4 rounded-xl border-2 border-green-300 shadow-sm dark:shadow-slate-900/30"
          >
          <h2
            class="text-base font-bold text-gray-900 dark:text-white mb-3 flex items-center gap-2"
            >
            <span class="text-lg">💵</span> Gains potentiels mensuels
          </h2>
          <!-- Grille 2 colonnes compacte -->
          <div class="grid grid-cols-2 gap-2 mb-3">
            <!-- Gaspillage évité -->
            <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-green-200 dark:border-green-800">
              <div class="text-xs text-gray-600 dark:text-gray-400 mb-0.5">🗑️ Gaspillage</div>
              <div class="text-xl font-bold text-green-600 dark:text-green-400">
                {{ formatCurrency(estimatedEconomies.wasteReduction) }}
              </div>
            </div>
            <!-- Ruptures évitées -->
            <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-green-200 dark:border-green-800">
              <div class="text-xs text-gray-600 dark:text-gray-400 mb-0.5">📦 Ruptures</div>
              <div class="text-xl font-bold text-green-600 dark:text-green-400">
                {{ formatCurrency(estimatedEconomies.avoidedRuptures) }}
              </div>
            </div>
          </div>
          <!-- Total & Temps sur 1 ligne -->
          <div class="grid grid-cols-2 gap-2">
            <!-- Total économie -->
            <div
              class="bg-gradient-to-br from-yellow-50 to-yellow-100 p-3 rounded-lg border-2 border-yellow-400 dark:border-yellow-700"
              >
              <div class="text-xs text-yellow-700 dark:text-yellow-300 mb-0.5 font-semibold">
                Total brut
              </div>
              <div class="text-2xl font-bold text-yellow-800 dark:text-yellow-300">
                {{ formatCurrency2(estimatedEconomies.total) }}
              </div>
              <div class="text-[10px] text-yellow-700 dark:text-yellow-300 mt-1 leading-tight">
                <div>- Abonnement: 29.90€</div>
                <div class="font-bold text-xs mt-0.5">
                  = {{ formatCurrency(estimatedEconomies.total - 29.9) }} net
                </div>
              </div>
            </div>
            <!-- Temps économisé -->
            <div
              class="bg-gradient-to-br from-blue-50 to-blue-100 p-3 rounded-lg border-2 border-blue-400 dark:border-blue-700"
              >
              <div class="text-xs text-blue-700 dark:text-blue-300 mb-0.5 font-semibold">
                ⏱️ Temps
              </div>
              <div class="text-2xl font-bold text-blue-800 dark:text-blue-300">
                {{ formatTimeSaved(estimatedEconomies.timeSaved) }}
              </div>
              <div class="text-[10px] text-blue-600 dark:text-blue-400 mt-1">économisé</div>
            </div>
          </div>
        </div>
        <!-- ============================================
        RECHERCHE ENRICHIE — Résultats géo
        ============================================ -->
        @if (enrichmentLoading) {
          <div
            class="bg-white dark:bg-slate-800 rounded-lg shadow-sm dark:shadow-slate-900/30 p-4 border border-gray-200 dark:border-slate-700"
            >
            <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
              <svg
                class="animate-spin h-4 w-4 text-indigo-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Chargement des données d'enrichissement…
            </div>
          </div>
        }
        @if (!enrichmentLoading && enrichmentAvailable) {
          <div
            class="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl border border-indigo-200 dark:border-indigo-800 shadow-sm dark:shadow-slate-900/30 overflow-hidden"
            >
            <div class="p-4">
              <h2
                class="text-base font-bold text-gray-900 dark:text-white mb-1 flex items-center gap-2"
                >
                <span class="text-lg">🔍</span> Analyse de votre emplacement
              </h2>
              @if (enrichmentAddress) {
                <p class="text-xs text-gray-500 dark:text-gray-400 mb-3">
                  📍 {{ enrichmentAddress }}
                </p>
              }
              <!-- Score global -->
              @if (scores) {
                <div class="mb-3">
                  <div
                    class="flex items-center gap-3 bg-white dark:bg-slate-800 rounded-lg p-3 border border-indigo-100"
                    >
                    <div
                      class="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold"
                [ngClass]="{
                  'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300': scores.overallScore >= 70,
                  'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300':
                    scores.overallScore >= 40 && scores.overallScore < 70,
                  'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300': scores.overallScore < 40,
                }"
                      >
                      {{ scores.overallScore }}
                    </div>
                    <div class="flex-1 min-w-0">
                      <div class="text-sm font-semibold text-gray-800 dark:text-gray-100">
                        Score global de l'emplacement
                      </div>
                      <div class="text-xs text-gray-500 dark:text-gray-400">
                        sur 100 — basé sur la fréquentation, l'accessibilité et le
                        potentiel commercial
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- Grille 2x2 KPIs -->
              @if (scores) {
                <div class="grid grid-cols-2 gap-2 mb-3">
                  <!-- Potentiel commercial -->
                  <div class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700">
                    <div
                      class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-0.5"
                      >
                      Potentiel commercial
                    </div>
                    <div
                      class="text-lg font-bold"
                [ngClass]="{
                  'text-green-600 dark:text-green-400': scores.businessPotential >= 70,
                  'text-yellow-600':
                    scores.businessPotential >= 40 &&
                    scores.businessPotential < 70,
                  'text-red-600 dark:text-red-400': scores.businessPotential < 40,
                }"
                      >
                      {{ scores.businessPotential }}/100
                    </div>
                    <div class="text-[10px] text-gray-400">
                      {{ scores.businessPotentialLabel }}
                    </div>
                  </div>
                  <!-- Fréquentation -->
                  <div class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700">
                    <div
                      class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-0.5"
                      >
                      Fréquentation piétonne
                    </div>
                    <div
                      class="text-lg font-bold"
                [ngClass]="{
                  'text-green-600 dark:text-green-400': scores.footTraffic >= 70,
                  'text-yellow-600':
                    scores.footTraffic >= 40 && scores.footTraffic < 70,
                  'text-red-600 dark:text-red-400': scores.footTraffic < 40,
                }"
                      >
                      {{ scores.footTraffic }}/100
                    </div>
                    <div class="text-[10px] text-gray-400">
                      {{ scores.footTrafficLabel }}
                    </div>
                  </div>
                  <!-- Concurrence → inversé pour afficher "opportunité" -->
                  <div class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700">
                    <div
                      class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-0.5"
                      >
                      Opportunité
                    </div>
                    <div
                      class="text-lg font-bold"
                [ngClass]="{
                  'text-green-600 dark:text-green-400': scores.competitionScore <= 30,
                  'text-yellow-600':
                    scores.competitionScore > 30 &&
                    scores.competitionScore <= 60,
                  'text-red-600 dark:text-red-400': scores.competitionScore > 60,
                }"
                      >
                      {{ 100 - scores.competitionScore }}/100
                    </div>
                    <div class="text-[10px] text-gray-400">
                      {{ competition?.count || scores.factors?.competitorCount || 0 }}
                      concurrent{{
                      (competition?.count || scores.factors?.competitorCount || 0) >
                      1
                      ? "s"
                      : ""
                      }}
                      à proximité
                    </div>
                  </div>
                  <!-- Accessibilité transport -->
                  <div class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700">
                    <div
                      class="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-0.5"
                      >
                      Transport / Accès
                    </div>
                    <div
                      class="text-lg font-bold"
                [ngClass]="{
                  'text-green-600 dark:text-green-400': scores.transportAccessibility >= 70,
                  'text-yellow-600':
                    scores.transportAccessibility >= 40 &&
                    scores.transportAccessibility < 70,
                  'text-red-600 dark:text-red-400': scores.transportAccessibility < 40,
                }"
                      >
                      {{ scores.transportAccessibility }}/100
                    </div>
                    <div class="text-[10px] text-gray-400">
                      {{ (scores.factors && scores.factors.transportCount) || 0 }}
                      arrêts proches
                    </div>
                  </div>
                </div>
              }
              <!-- Zone & Flux déduits -->
              @if (zoneEconomique || fluxClient) {
                <div
                  class="grid grid-cols-2 gap-2 mb-3"
                  >
                  @if (zoneEconomique) {
                    <div
                      class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-indigo-100"
                      >
                      <div
                        class="text-[10px] text-indigo-500 uppercase tracking-wide mb-0.5"
                        >
                        Zone économique
                      </div>
                      <div class="text-sm font-semibold text-indigo-800">
                        {{ zoneEconomique }}
                      </div>
                    </div>
                  }
                  @if (fluxClient) {
                    <div
                      class="bg-white dark:bg-slate-800 p-2.5 rounded-lg border border-purple-100"
                      >
                      <div
                        class="text-[10px] text-purple-500 uppercase tracking-wide mb-0.5"
                        >
                        Flux client
                      </div>
                      <div class="text-sm font-semibold text-purple-800 dark:text-purple-300">
                        {{ fluxClient }}
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- Démographie -->
              @if (demographics) {
                <div
                  class="bg-white dark:bg-slate-800 rounded-lg p-3 border border-gray-100 dark:border-slate-700 mb-3"
                  >
                  <div class="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    📊 Démographie{{
                    demographics.commune?.name
                    ? " — " + demographics.commune?.name
                    : ""
                    }}
                  </div>
                  <div class="grid grid-cols-3 gap-2 text-center">
                    <div>
                      <div class="text-base font-bold text-gray-800 dark:text-gray-100">
                        {{ (demographics.population || 0).toLocaleString("fr-FR") }}
                      </div>
                      <div class="text-[10px] text-gray-400">Habitants</div>
                    </div>
                    <div>
                      <div class="text-base font-bold text-gray-800 dark:text-gray-100">
                        {{ (demographics.density || 0).toLocaleString("fr-FR") }}
                      </div>
                      <div class="text-[10px] text-gray-400">hab/km²</div>
                    </div>
                    @if (demographics.medianIncome) {
                      <div>
                        <div class="text-base font-bold text-gray-800 dark:text-gray-100">
                          {{
                          (demographics.medianIncome || 0).toLocaleString("fr-FR")
                          }}€
                        </div>
                        <div class="text-[10px] text-gray-400">Revenu médian</div>
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- Zone touristique badge -->
              @if (scores?.touristZone) {
                <div
                  class="inline-flex items-center gap-1.5 bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300 px-3 py-1 rounded-full text-xs font-medium mb-3"
                  >
                  🏖️ Zone touristique détectée — score {{ scores?.touristScore }}/100
                </div>
              }
              <!-- Insights IA -->
              @if (scores?.insights?.length) {
                <div
                  class="bg-white dark:bg-slate-800 rounded-lg p-3 border border-gray-100 dark:border-slate-700"
                  >
                  <div class="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2">
                    💡 Points clés
                  </div>
                  <ul class="space-y-1">
                    @for (insight of scores?.insights; track insight) {
                      <li
                        class="text-xs text-gray-600 dark:text-gray-400 flex items-start gap-1.5"
                        >
                        <span class="text-indigo-400 mt-0.5">•</span>
                        <span>{{ insight }}</span>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
        }
        <!-- Pas d'enrichissement disponible — afficher au moins l'adresse -->
        @if (!enrichmentLoading && !enrichmentAvailable) {
          <div
            class="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl border border-gray-200 dark:border-slate-700 overflow-hidden"
            >
            <div class="p-4">
              <h2
                class="text-base font-bold text-gray-900 dark:text-white mb-2 flex items-center gap-2"
                >
                <span class="text-lg">🔍</span> Votre emplacement
              </h2>
              <!-- Adresse saisie -->
              @if (enrichmentAddress) {
                <div
                  class="bg-white dark:bg-slate-800 rounded-lg p-3 border border-gray-100 dark:border-slate-700 mb-3"
                  >
                  <div class="flex items-start gap-2">
                    <span class="text-base mt-0.5">📍</span>
                    <div>
                      <div class="text-sm font-semibold text-gray-800 dark:text-gray-100">
                        {{ enrichmentAddress }}
                      </div>
                      @if (enrichmentCity) {
                        <div
                          class="text-xs text-gray-500 dark:text-gray-400 mt-0.5"
                          >
                          {{ enrichmentCity }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              <!-- Info enrichissement en cours -->
              <div
                class="flex items-center gap-2 p-2.5 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100"
                >
                <svg
                  class="animate-spin h-3.5 w-3.5 text-blue-500 flex-shrink-0"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <p class="text-xs text-blue-700 dark:text-blue-300">
                  L'analyse détaillée de votre emplacement est en cours — elle sera
                  disponible depuis votre dashboard.
                </p>
              </div>
            </div>
          </div>
        }
        <!-- Aucune adresse saisie -->
        @if (!enrichmentLoading && !enrichmentAvailable && !enrichmentAddress) {
          <div
            class="bg-gray-50 dark:bg-slate-900 rounded-lg p-3 border border-gray-200 dark:border-slate-700"
            >
            <p class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1.5">
              <span>📍</span>
              <span
                >Aucune adresse renseignée — vous pourrez ajouter votre localisation
                depuis le dashboard.</span
                >
              </p>
            </div>
          }
          <!-- ============================================
          RÉCAPITULATIF COMPACT
          ============================================ -->
          <div class="bg-white dark:bg-slate-800 rounded-lg shadow-sm dark:shadow-slate-900/30 p-4 border border-gray-200 dark:border-slate-700">
            <h2
              class="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"
              >
              <span class="text-lg">📊</span> Votre profil
            </h2>
            <!-- Version FIXE -->
            @if (merchantType === 'fixed') {
              <div
                class="flex flex-wrap gap-2 text-sm"
                >
                <span
                  class="inline-flex items-center gap-1.5 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-indigo-600">Type:</span>
                  <span>Marchand fixe</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-blue-600 dark:text-blue-400">Équipe:</span>
                  <span>{{ teamSizeLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-purple-600">Affluence:</span>
                  <span>{{ affluenceLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-pink-100 text-pink-800 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-pink-600">Fréquence:</span>
                  <span>{{ periodiciteLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-green-600 dark:text-green-400">Services:</span>
                  <span>{{ servicesLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-orange-600">Protection:</span>
                  <span>{{ coverageLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-teal-100 text-teal-800 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-teal-600">Activité:</span>
                  <span>{{ activityTypeLabel || activityTypeFallbackLabel }}</span>
                </span>
                @if (positioningLabel) {
                  <span
                    class="inline-flex items-center gap-1.5 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 px-3 py-1.5 rounded-full font-medium"
                    >
                    <span class="text-xs text-yellow-600">Positionnement:</span>
                    <span>{{ positioningLabel }}</span>
                  </span>
                }
              </div>
            }
            <!-- Version ITINÉRANT -->
            @if (merchantType === 'itinerant') {
              <div
                class="flex flex-wrap gap-2 text-sm"
                >
                <span
                  class="inline-flex items-center gap-1.5 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-indigo-600">Type:</span>
                  <span>Marchand itinérant</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-blue-600 dark:text-blue-400">Équipe:</span>
                  <span>{{ teamSizeLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-purple-600">Événements:</span>
                  <span>{{ eventTypesLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-orange-600">Protection:</span>
                  <span>{{ coverageLabel }}</span>
                </span>
                <span
                  class="inline-flex items-center gap-1.5 bg-teal-100 text-teal-800 px-3 py-1.5 rounded-full font-medium"
                  >
                  <span class="text-xs text-teal-600">Activité:</span>
                  <span>{{ activityTypeLabel || activityTypeFallbackLabel }}</span>
                </span>
                @if (positioningLabel) {
                  <span
                    class="inline-flex items-center gap-1.5 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 px-3 py-1.5 rounded-full font-medium"
                    >
                    <span class="text-xs text-yellow-600">Positionnement:</span>
                    <span>{{ positioningLabel }}</span>
                  </span>
                }
              </div>
            }
          </div>
          <!-- Info box compact -->
          <div class="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
            <p class="text-xs text-blue-700 dark:text-blue-300">
              <span class="font-semibold">ℹ️ Note :</span> Estimations basées sur
              des profils similaires. La précision s'améliore avec l'utilisation.
            </p>
          </div>
          <!-- Boutons -->
          <div class="flex gap-2 mt-4">
            <button
              (click)="goBack()"
              class="flex items-center gap-1 px-4 py-1.5 text-sm text-gray-600 dark:text-gray-400 font-medium bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 transition"
              >
              ← Retour
            </button>
            <button
              (click)="finalize()"
              [disabled]="isNavigating"
              class="flex-1 px-4 py-1.5 text-sm bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold rounded-lg transition shadow-md dark:shadow-slate-900/50 disabled:opacity-50"
              >
              @if (!isNavigating) {
                <span>✨ Accéder au dashboard</span>
              }
              @if (isNavigating) {
                <span>Chargement...</span>
              }
            </button>
          </div>
        </div>
      }
    </div>
  </div>
